/**
 * Queue feature flags.
 *
 * Centralised toggles for queue features whose backend support is
 * incomplete. Flip to `true` once the corresponding endpoints ship.
 */

/**
 * Operator assignment (claim items to a specific operator tag).
 *
 * Backend endpoints now live in the operations service (Task 3201a):
 *   - GET    /v1/attention/assignments
 *   - POST   /v1/attention/{id}/assign
 *   - DELETE /v1/attention/{id}/assign
 *
 * Items remain visible to all operators regardless of claim — the chip is
 * informational + filterable, not a visibility gate.
 */
export const ASSIGNMENT_ENABLED = true
